<template>
  <div class="video-container">
    <ml-header :navigate-to="goBackHome" />
    <div class="my-video-container">
      <div v-if="loading" class="video-loading">
        <p>视频加载中...</p>
      </div>
      <div v-else class="video">
        <VideoPlayer
          :options="videoOptions"
          :video-id="Number($route.params.id)"
          :poster="video.firstFrame"
          @exceed-limit-times="handleExceedTimes"
        />
      </div>
    </div>
    <div class="content">
      <p class="name">{{ video.name }}</p>
      <ul class="tag-container">
        <li v-for="(tag, index) in tags" :key="index">
          {{ tag.name.slice(1, tag.name.length - 1) }}
        </li>
      </ul>
      <Banner type="video" />
      <h2>相关视频</h2>
      <GridLayoutVideo :videos="videos" />
    </div>
    <ml-popup :open.sync="isPopupOpen">
      <h1>温馨提示</h1>
      <p>
        今天免费次数已看完，每个用户每天免费看{{
          total
        }}个视频，开通VIP会员无限观看
      </p>
      <div class="popup-buttons">
        <ml-button
          width="100%"
          class="first-button"
          border-color="rgba(230,230,230,1)"
          text-color="rgba(102,102,102,1)"
          @click="$router.push({ name: 'invite' })"
          s
          >免费领取VIP</ml-button
        >
        <ml-button
          width="100%"
          :is-theme-color="true"
          @click="$router.push({ name: 'vip' })"
          >开通VIP会员</ml-button
        >
      </div>
    </ml-popup>
  </div>
</template>

<script>
import NProgress from "nprogress";
import VideoPlayer from "./components/VideoPlayer";
import GridLayoutVideo from "@/views/video/components/GridLayoutVideo";
import { getRelativeVideos } from "@/api/video";
import { getVideoRelativeTags } from "@/api/video";
import { getVideoDetail } from "@/api/video";
import Banner from "@/components/Banner";

export default {
  name: "VideoPlay",
  components: {
    VideoPlayer,
    GridLayoutVideo,
    Banner
  },
  watch: {
    $route: function() {
      this.fetchData();
    }
  },
  data() {
    return {
      video: {},
      tags: [],
      videos: [],
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: ""
      },
      isPopupOpen: false,
      total: null,
      loading: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      NProgress.start();
      this.loading = true;
      const id = this.$route.params.id;
      const videoPending = getVideoDetail(id);
      const videosPending = getRelativeVideos(id);
      const tagPending = getVideoRelativeTags(id);
      this.video = await videoPending;
      this.tags = await tagPending;
      this.videos = await videosPending;
      this.videoOptions.sources = this.video.url;
      this.loading = false;
      NProgress.done();
    },
    goBackHome() {
      this.$router.push({ name: "video" });
    },
    handleExceedTimes(total) {
      this.isPopupOpen = true;
      this.total = total;
    }
  }
};
</script>

<style lang="scss">
.video-container {
  .my-video-container {
    height: 196px;
    .video {
      height: 100%;
      width: 100%;
    }
    .video-loading {
      height: 100%;
      width: 100%;
      background-color: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    margin: 10px 15px;
    text-align: left;
    .name {
      margin: 10px 0;
      font-size: 15px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 21px;
      line-height: 21px;
    }
    .album {
      width: 100%;
      height: 145px;
      border-radius: 6px;
      overflow: hidden;
      background-color: #e4e4e4;
    }
    .tag-container {
      margin-bottom: 17px;
      min-height: 20px;
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 10px;
        height: 100%;
        line-height: 20px;
        background: rgba(229, 192, 92, 0.1);
        border-radius: 11px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(229, 192, 92, 1);
        text-align: center;
        white-space: nowrap;
      }
    }
    h2 {
      margin: 20px 0 12px 0;
      font-size: 18px;
      font-weight: 500;
      color: rgba(50, 51, 51, 1);
      line-height: 25px;
    }
    .video-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      grid-gap: 10px;
    }
  }
}
.popup-buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .first-button {
    margin-right: 20px;
  }
}
</style>
